<template>
  <ListingBlock
    class="podcasts-block"
    :view="view"
    :docs="view.docs().filteredDocs"
  />
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'

import type { ListView } from '@/models/docs.list'

defineProps<{
  view: ListView
}>()
</script>

<style lang="scss" scoped>
.podcasts-block {
  --listing-block-number-of-columns: 4;
}
</style>
